// In-memory + session cache for Listing Management so the page can paint
// from a Home prewarm instead of blocking on ?type=listings.

const CACHE_TTL_MS = 2 * 60 * 1000;
const SESSION_PREFIX = 'ipm.listings.v1.';

let _cache = {};

export function listingsCacheKey(userId, isAgency) {
  return `${userId}-${isAgency ? '1' : '0'}`;
}

function readSession(key) {
  try {
    const raw = sessionStorage.getItem(SESSION_PREFIX + key);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (!entry?.data || Date.now() - entry.timestamp > CACHE_TTL_MS) return null;
    return entry;
  } catch (_) {
    return null;
  }
}

export function getListingsCache(key) {
  if (!key) return null;
  const mem = _cache[key];
  if (mem && Date.now() - mem.ts <= CACHE_TTL_MS) return mem.data;
  if (mem) delete _cache[key];
  const session = readSession(key);
  if (!session) return null;
  _cache[key] = { data: session.data, ts: session.timestamp };
  return session.data;
}

export function setListingsCache(key, data) {
  if (!key || !data) return;
  const ts = Date.now();
  _cache[key] = { data, ts };
  try {
    sessionStorage.setItem(SESSION_PREFIX + key, JSON.stringify({ data, timestamp: ts }));
  } catch (_) {
    try { sessionStorage.removeItem(SESSION_PREFIX + key); } catch (__) {}
  }
}

export function invalidateListingsCache(key) {
  if (key) {
    delete _cache[key];
    try { sessionStorage.removeItem(SESSION_PREFIX + key); } catch (_) {}
  } else {
    _cache = {};
  }
}
